// extracted by mini-css-extract-plugin
export default {"div":"PriceCard_div__Yofbu","price":"PriceCard_price__0RyfF"};